import React from 'react';
import Autocomplete from 'react-google-autocomplete';
import { TextField } from '@mui/material';
import { KEY_GOOGLE_MAPS } from '../config/constants';

const GooglePlacesInput = ({ onPlaceSelected }) => {

  const handlePlaceSelection = (place) => {
    const country = place.address_components.find((component) =>
      component.types.includes("country")
    );
    const locality = place.address_components.find((component) =>
      component.types.includes("locality")
    );
    const administrative_area_level_2 = place.address_components.find(
      (component) => component.types.includes("administrative_area_level_2")
    );
    const administrative_area_level_1 = place.address_components.find(
      (component) => component.types.includes("administrative_area_level_1")
    );
    const codePostal = place.address_components.find((component) =>
      component.types.includes("postal_code")
    );

    const addressNew = place.address_components.find((component) =>
      component.types.includes("route")
    );
    const numberAddress = place.address_components.find((component) =>
      component.types.includes("street_number")
    );

    const pais = country?.long_name || "";
    const localidad = locality?.long_name || "";
    const municipio = administrative_area_level_2?.long_name || "";
    const codigoPostal = codePostal?.long_name || "";
    const provincia = administrative_area_level_1?.short_name || "";
    const calle = addressNew?.long_name || "";
    const numero = numberAddress?.long_name || "";
    onPlaceSelected({calle, numero, codigoPostal, localidad, municipio, provincia, pais });
   }

  return (
    <div style={{ marginTop: '2px' }}>
      <TextField
        label="Domicilio"
        InputLabelProps={{
          shrink: true, // Esto asegura que el label esté en modo shrink
        }}
        InputProps={{
          inputComponent: AutocompleteWrapper, // Envolvemos Autocomplete dentro de TextField
          inputProps: {
            placeholder: 'Ingresa tu domicilio',
            handlePlaceSelection, // Pasamos onPlaceSelected al AutocompleteWrapper
          },
        }}
        fullWidth
        variant="outlined"
      />
    </div>
  );
};

const AutocompleteWrapper = ({ inputRef, handlePlaceSelection, ...props }) => (
  <Autocomplete
    apiKey={KEY_GOOGLE_MAPS} // Reemplaza con tu clave de API
    style={{
      width: '100%',
      height: '1.4375em',
      marginTop: '6px',
      padding: '6.5px 14px',
      borderRadius: '4px',
      borderColor: '#ced4da',
      boxSizing: 'border-box',
    }}
    onPlaceSelected={(place) => {
      // Llama al callback con los detalles seleccionados
      if (handlePlaceSelection) {
        handlePlaceSelection(place);
      }
    }}
    options={{
      types: ['address'], // Filtra solo direcciones
    }}
    {...props} // Pasa el resto de las propiedades a Autocomplete
  />
);

export default GooglePlacesInput;
